const HoldingStatusEnum = Object.freeze({
    DRAFT: 'DRAFT',
    OPEN: 'OPEN',
    CLOSED: 'CLOSED'
});

export default HoldingStatusEnum;
